import { RESOURCE } from "~/utils/urlApi";
import * as api from "~/api";
import { createQueryString } from "~/utils/func";

export const getTermOfService = () => {
  return api.getHttpRequestAsync(RESOURCE.GET_TERM_OF_SERVICE);
};

export const getIntroduction = () => {
  return api.getHttpRequestAsync(RESOURCE.GET_INTRODUCTION);
};

export const getPrivatePolicy = () => {
  return api.getHttpRequestAsync(RESOURCE.GET_PRIVATE_POLICY);
};

export const getUsageRules = () => {
  return api.getHttpRequestAsync(RESOURCE.GET_USAGE_RULES);
};

// checked
export const getTermBeforeLogin = () => {
  return api.getHttpRequestAsync(RESOURCE.GET_TERM_BEFORE_LOGIN);
};

export const apiRequestHoliday = baseUrl => {
  return api.getHttpRequestAsync(`${baseUrl}${RESOURCE.GET_HOLIDAY}`);
};

export const apiRequestBannerList = (type = 2) => {
  return api.getHttpRequestAsync(RESOURCE.GET_ALL_BANNER + "?type=" + type);
};

// checked
export const apiRequestAllCareers = baseUrl => {
  return api.getHttpRequestAsync(`${baseUrl}${RESOURCE.GET_ALL_PROFESSION}`);
};

// checked
export const apiRequestAllCitiesByCountry = (baseUrl, data) => {
  const url = createQueryString(`${baseUrl}${RESOURCE.GET_CITY}`, data);
  return api.getHttpRequest(url);
};

// checked
export const apiRequestallCountries = baseUrl => {
  return api.getHttpRequestAsync(`${baseUrl}${RESOURCE.GET_ALL_COUNTRY}`);
};

// checked
export const requestAllDistrictsByCity = (baseUrl, data) => {
  const url = createQueryString(`${baseUrl}${RESOURCE.GET_DISTRICT}`, data);
  return api.getHttpRequest(url);
  // return api.getHttpRequestAsync(`${baseUrl}${RESOURCE.GET_DISTRICT}${id}`);
};

// checked
export const apiRequestAllNation = baseUrl => {
  return api.getHttpRequestAsync(`${baseUrl}${RESOURCE.GET_NATION}`);
};

// checked
export const requestAllWardsByDistrict = (baseUrl, data) => {
  const url = createQueryString(`${baseUrl}${RESOURCE.GET_WARD}`, data);
  return api.getHttpRequest(url);
  // return api.getHttpRequestAsync(`${baseUrl}${RESOURCE.GET_WARD}${id}`);
};

// checked
export const apiRequestAllRelationShip = baseUrl => {
  return api.getHttpRequestAsync(`${baseUrl}${RESOURCE.GET_ALL_RELATIONSHIP}`);
};
